import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ConversionService } from '@cosmos/angular/utils';
import { Device, LoraMetadata } from '@cosmos/shared';
import { TranslatePipe } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'cosmos-device-card',
  imports: [TranslatePipe, NgClass, RouterModule,
    CardModule, ButtonModule, DividerModule,
  ],
  templateUrl: './device-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceCardComponent {
  private readonly conversionService = inject(ConversionService);

  readonly device = input.required<Device>();
  readonly showNavigation = input(false);
  /** Explicit project context for the nav links. Callers that already know the
   *  project (e.g. the project-scoped devices page) pass it here; otherwise it
   *  falls back to `device.project`. */
  readonly projectId = input<string>('');

  /** Resolved project id for the "/projects/:id/…" nav links — the explicit
   *  input wins, else `device.project` whether populated ({ _id }) or a bare
   *  id string. Empty ⇒ nav footer is hidden. */
  readonly resolvedProjectId = computed(() => {
    if (this.projectId()) return this.projectId();
    const p = this.device().project as { _id?: string } | string | undefined;
    return (typeof p === 'string' ? p : p?._id) ?? '';
  });

  getTransmissionDetails(transmission: LoraMetadata) {
    return this.conversionService.getTransmissionInfo(transmission);
  }

  getBattery(battery: number) {
    return this.conversionService.getBatteryInfo(battery);
  }
}
